import { useTranslation } from 'react-i18next';

export const useTabs = () => {
  const { t } = useTranslation();

  return [
    { label: t('pages.channel_guides.detail.tabs.channels'), to: '../channels' },
    { label: t('common.labels.settings'), to: '../settings' },
    { label: t('common.tabs.audit_logs'), to: '../audit-logs' },
  ];
};
